import { useEffect, useState } from 'react';
import { useNotificationProvider } from 'hooks';
import { getIncidentReportData } from 'api/generateIncidentReports/getIncidentReportData';
import { getChecklist, getCheckpoints } from 'api/checklists/checklistsAPI';

/**
 * @function useIncidentGenerator
 * @returns
 */
function useIncidentGenerator() {
	const { notifyError } = useNotificationProvider();
	const [pending, setPending] = useState(true);
	const [incidentData, setIncidentData] = useState(null);

	const fetchIncidentDataData = async () => {
		const queryParams = new URLSearchParams(window.location.search);

		const scheduleAssignmentID = queryParams.get('said');
		const checklistID = queryParams.get('clid');

		if (scheduleAssignmentID === '0' && checklistID) {
			const checklist = await getChecklist(checklistID);
			const checkpoints = await getCheckpoints(checklistID);
			const incidentChecklist = {
				...checklist,
				Checkpoints: checkpoints,
			};
			const dummyPreview = {
				ScheduleAssignmentID: 9999999,
				CommentListID: 999999,
				StartTime: new Date(),
				GuardName: 'John Doe',
				Customer: 'LNN Protection',
				Address: '123 Main St, Calgary, AB',
				IncidentChecklist: incidentChecklist,
			};
			setIncidentData(dummyPreview);
			setPending(false);
		} else if (scheduleAssignmentID && checklistID) {
			const incidentData = await getIncidentReportData(
				scheduleAssignmentID,
				checklistID,
			);
			console.log(incidentData);
			if (incidentData !== -1) {
				setPending(false);
				setIncidentData(incidentData);
			} else {
				notifyError('Error generating incident report');
				setPending(false);
			}
		} else {
			notifyError('Invalid URL');
			setPending(false);
		}
	};

	useEffect(() => {
		fetchIncidentDataData();
	}, []);

	return {
		pending,
		incidentData,
	};
}

export default useIncidentGenerator;
